var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartner1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 23,
    viewBox: "0 0 25 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.46891 20.75L1.24167 6.49999C-0.105484 4.16666 1.57846 1.25 4.27276 1.25H20.7272C23.4215 1.25 25.1055 4.16667 23.7583 6.5L15.5311 20.75C14.1839 23.0833 10.8161 23.0833 9.46891 20.75Z",
    fill: "#CDDC39",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartner1);
export default __webpack_public_path__ + "static/media/Partner1.2bf3d8853686f1ea2f4c453b498e8292.svg";
export { ForwardRef as ReactComponent };